//React components 
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
//Components 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import { Container } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { PowetranzFetchAPI } from '../../api/Powertranz';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { MachinesFetchAPI } from '../../api/Machines';
import { OrderNumberFetchAPI } from '../../api/OrderNumber';
import { Modal, Button } from 'react-bootstrap';
import DocPdf from '../Pdf/DocPdf';
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';


const OrderDetailPreOrder = ({ orderData, userBranchoffices, handlerUpdatePreOrder, handleCloseModal, statusDetailModalDinamic, branchOfficeData }) => {
    const [newBranchoffice, setNewBranchoffice] = useState({});
    const { business_code } = useParams()
    const [formatVoucher, setformatVoucher] = useState("");
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)

    //Total taxes 
    const [totalTaxes, setTotalTaxes] = useState([
        { total_base: 0, tax: "0%", total_tax: 0 },
        { total_base: 0, tax: "7%", total_tax: 0 },
        { total_base: 0, tax: "10%", total_tax: 0 },
        { total_base: 0, tax: "15%", total_tax: 0 }
    ]);

    const handleViewCoucher = () => {
        formatVoucherString()
        setmodalShowVoucher(true)
    }

    //-----------------------POWERTRANZ FUNCTIONS -----------------------//
    //Void powertranz
    const voidPowertranz = async () => {

        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz
        LoadingAlert("Anulando pago...", "Por favor espere mientras se procesa la anulacion del pago...");
        console.log(dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier);
        try {
            let token = localStorage.getItem('x-access-token')
            console.log(dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier);
            let data = { "TransactionIdentifier": dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier }
            console.log("data", data);

            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password,
            }
            const response = await PowetranzFetchAPI.void(data, headers);
            let approved = response.data.data.Approved;
            let responseVoidData = dataPowetranz
            responseVoidData.powertranzResponse = response.data.data

            let datafilter = response.data.data
            const now = new Date(); // Gets current date and time
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
            const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
            responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
            let newVoucher = { EMVStreamResponse: responseVoidData }
            if (approved == true) {
                deleteTempPreOrder(order_code, responseVoidData, true)
            } else {
                refundPowertranz()
            }

        } catch (err) {
            ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
            console.log(err);
        }
    }

    //Refund powertranz
    const refundPowertranz = async () => {
        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz
        try {
            let token = localStorage.getItem('x-access-token')
            let data = { "TransactionIdentifier": dataPowetranz?.TransactionIdentifier || dataPowetranz?.powertranzResponse?.TransactionIdentifier }

            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password
            }
            const response = await PowetranzFetchAPI.refund(data, headers);
            let approved = response.data.data.Approved;
            let responseVoidData = dataPowetranz
            responseVoidData.powertranzResponse = response.data.data

            let datafilter = response.data.data
            const now = new Date(); // Gets current date and time
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
            const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
            responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
            let newVoucher = { EMVStreamResponse: responseVoidData }
            if (approved == true) {
                deleteTempPreOrder(order_code, newVoucher, true)
            }
        } catch (err) {
            ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
            console.log(err);
        }
    }

    //delete pre order true
    const deleteTempPreOrder = async (temporal_orden_code, newVoucher, statusDeleted, transaction_code, orden_code) => {

        let token = localStorage.getItem('x-access-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
        let branch_code = branchoffice.code

        let jsonUpdate = {
            "order_code": temporal_orden_code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
        }

        console.log(newVoucher);
        if (newVoucher !== undefined && newVoucher !== null) {
            console.log("entre aqui");
            jsonUpdate.justification = "Orden rechazada"
            jsonUpdate.EMVStreamResponse = newVoucher
        }

        if (statusDeleted == true) {
            jsonUpdate.deleted = true
            jsonUpdate.status = 5
        } else {
            jsonUpdate.deleted = false
            jsonUpdate.status = 3
            jsonUpdate.finished_order_transaction_code = transaction_code
            jsonUpdate.finished_order_code = orden_code
        }

        try {
            await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);
            const response = await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)
            handleCloseModal();
            handlerUpdatePreOrder();
            if (statusDeleted == true) {
                ErrorAlert("Precuenta a sido rechazada.", "La orden se rechazo con exito.", "success")
            }


        } catch (err) {
            console.log(err);
        }

    }

    const capturePowertranz = async (TotalAmount) => {
        LoadingAlert("Capturando pago...", "Por favor espere mientras se procesa la captura del pago...");
        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz

        try {
            let token = localStorage.getItem('x-access-token')
            let data = { "TransactionIdentifier": dataPowetranz.TransactionIdentifier, "TotalAmount": TotalAmount }
            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password
            }



            const response = await PowetranzFetchAPI.capture(data, headers);
            let dataTemp = {}
            dataTemp.X_PowerTranz_Password = dataPowetranz?.X_PowerTranz_Password;
            dataTemp.X_PowerTranz_Id = dataPowetranz?.X_PowerTranz_Id;
            dataTemp.X_PowerTranz_BaseUrl = dataPowetranz?.X_PowerTranz_BaseUrl
            dataTemp.TransactionIdentifier = dataPowetranz?.TransactionIdentifier
            dataTemp.powertranzResponse = response.data.data
            let datafilter = response.data.data


            if (datafilter?.Approved == true) {

                const now = new Date(); // Gets current date and time
                const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
                const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
                dataTemp.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\nPAYMENT METHOD:             ${datafilter.CardBrand}\r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
                lastOrderMachineRequest(dataTemp)
                ErrorAlert("Pago capturado con exito.", "La orden se aprobo con exito.", "success")
            } else {
                ErrorAlert("No se capturo el pago.", "Error en la captura del pago", "error")
            }
        } catch (err) {
            ErrorAlert("No se capturo el pago.", "Error en la captura del pago", "error")
            console.log(err);
        }
    }

    //-----------------------END POWERTRANZ FUNCTIONS -----------------------//

    //-----------------------REGISTER FUNCTIONS -----------------------//
    const [registerTurnOrder, setRegisterTurnOrder] = useState(0);
    //get last order in this machine
    const lastOrderMachineRequest = async (newVoucher) => {
        let token = localStorage.getItem('x-access-token');
        try {
            const response = await MachinesFetchAPI.lastOrderMachine(orderData.machine_id, token);
            getOrderNumber(response.data.last_order._id, newVoucher)
        } catch (err) {
            console.log(err)
        }
    }

    // get order number in process
    const getOrderNumber = async (lastOrder_id, newVoucher) => {
        let token = localStorage.getItem('x-access-token');
        try {
            const response = await OrderNumberFetchAPI.getOrderNumber(orderData?.branchoffice?.id || 0, token)
            let orderNumber = (parseInt(response.data.last_transaction_code) + 1)
            registernewOrder(newVoucher, lastOrder_id, orderNumber)
        } catch (err) {
            console.log(err);
        }
    }

    //function register order

    const registernewOrder = async (detailEMVStreamResponse, lastOrder_id, orderNumber) => {

        let token = localStorage.getItem('x-access-token')
        LoadingAlert("Registrando orden...", "Espere un momento por favor...")

        //We check if the order is not registered
        if (registerTurnOrder == 0) {
            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            let machine = JSON.parse(localStorage.getItem('machine'));
            let json = {
                "user_id": 0,
                "EMVStreamResponse": detailEMVStreamResponse,
                "transaction_code": orderNumber,
                "client_name": orderData.client_name,
                "client_id": orderData.client_id,
                "ruc": orderData.client_ruc,
                "dv": orderData.client_dv,
                "localizador": "00",
                "client_phone": orderData.client_phone,
                "dgi_qr": "0",
                "Orden": orderData.groups,
                "combos": orderData.combos,
                "Descuento": orderData.discount,
                "Total": orderData.total,
                "itbms": orderData.tax,
                "tips": orderData.tips || 0,
                "taxes": orderData.taxes,
                "direction": orderData.direction,
                "subtotal": orderData.subtotal,
                "machine_id": orderData.machine_id,
                "branchoffice_id": orderData?.branchoffice?.id || 0,
                "tipoOrden": orderData.order_type,
                "paymethod": orderData.paymenthod_id,
                "paymethods": [],
                "discounts": orderData.discounts,
                "paymenthod_integration_id": orderData.paymenthod_integration_id !== undefined ? orderData.paymenthod_integration_id : 0,
                "parthner_order": false,
            }


            try {
                const response = await OrderNumberFetchAPI.registerOrder(json, token)
                ErrorAlert("Orden registrada con exito", "Orden generada", "success")
                setRegisterTurnOrder(1);
                //SuccessAlert("Orden registrada con exito", "Orden generada", "success")
                deleteTempPreOrder(orderData.code, undefined, false, response.data.data.transaction_code, response.data.data.order_code)


                /*const tieneReserva = shoppingcart.find(item => ,item.type === "reservable");
                //We check if the delivery rule is asap to send the order to asap
                if (selectedDeliveryRule != null && selectedDeliveryRule != undefined) {
                    if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "asap") {
                        try {
                            await registerAsapOrder(response.data.data.order_id)
                        } catch (err) {
                            console.log(err)
                        }
                    }
                }
                // Retorna true si existe al menos una reserva, false si no
                if (tieneReserva) {
                    // Si hay reservas, se ejecuta esta lógica
                    putOrderReservedCode(response.data.data.order_code, response.data.data.id_order, tieneReserva)
                } else {
                    AlertSmall("Orden registrada con exito", "success")
                    navigate(`/order/${response.data.data.order_code}`);
                }


                clearShoppingCartlocalStorage();*/
            } catch (err) {
                //valid to id of transaction

                /*if (err.response.data.error === "La máquina está ocupada. Intenta en unos segundos.") {

                    setRegisterTurnOrder(0)
                    //ErrorAlert("", err.response.data.error, "error")
                    alertOption()

                } else {
                    try {
                        let token = localStorage.getItem('x-access-machine-token');
                        const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

                        if (response.data.last_order._id == lastOrder_id) {

                            setRegisterTurnOrder(0)
                            //ErrorAlert("", "Ocurrio un error", "error")
                            alertOption()
                        } else {
                            setDataTransaction_code(response.data.last_order.transaction_code);
                            setOrder_id(response.data.last_order.order_id)
                            setOrderCode(response.data.last_order.order_code)
                            setRegisterTurnOrder(1);
                            ErrorAlert("Orden registrada con exito", "Orden generada", "success")
                            //navigate(`/order/${response.data.data.order_code}/branchoffice/${branchoffice.id}/${business_code}/${branchoffice_code}/${machine_code_table}`);
                          

                        }
                    } catch (err) {
                        console.log(err)
                    }
                }


                function alertOption() {
                    Swal.fire({
                        title: err.response.data.error,
                        text: "¡Intenta de nuevo el resgistro en un momento!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Intentar de nuevo",
                        cancelButtonText: "No, intentar de nuevo"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            registernewOrder(detailEMVStreamResponse, paymentInfo)
                        }
                    });
                }*/
            }
        } else {
            console.log("Hay una orden en proceso");
        }



    }
    //-----------------------------------------------------------------------//

    //Function to populate the users branch 
    const branchList = () => {
        const listBracnh = userBranchoffices.map((branch) => (
            <>
                <option value={JSON.stringify(branch)}>{branch.branchoffice_name}</option>
            </>
        ));
        return listBracnh
    }

    //put preOrder change branchoffice
    const updatePreOrder = async () => {
        if (newBranchoffice != "0") {
            let token = localStorage.getItem('x-access-token')
            let dataBranchoffice = JSON.parse(newBranchoffice);
            try {

                const responseBranchOffice = await BranchOfficeFetchAPI.getBranchOfficesByid(dataBranchoffice.branchoffice_id, token);
                let dataResponseBranchoffice = responseBranchOffice.data.data.branchoffice;
                let data = {
                    "_id": orderData._id,
                    "groups": orderData.groups,
                    "branchoffice": {
                        "id": dataResponseBranchoffice.branchoffice_id,
                        "code": dataResponseBranchoffice.code,
                        "name": dataResponseBranchoffice.name,
                        "ruc": dataResponseBranchoffice.ruc,
                        "dv": dataResponseBranchoffice.dv
                    }
                }

                const response = await PreOrderFetchAPI.updateOrderTempPreOrder(data, token)
                handleCloseModal();
                handlerUpdatePreOrder();
                ErrorAlert("", "Se asigno la precuenta a la otra sucursal", "success")

            } catch (err) {
                ErrorAlert('', 'Lo sentimos ocurrio un error', 'error');
                console.log(err);
            }
        } else {
            ErrorAlert('', 'Debes seleccionar una sucursal', 'info');
        }

    }

    //We charge the items of the order 
    const orderItems = () => {
        let items = orderData.groups.map((product) => (
            <div className="d-flex text-muted pt-3 px-xs-2" key={product._id}>
                <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" loading="lazy" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" })} width="42" height="42" />
                <div className="pb-3 mb-0  lh-sm  w-100">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-dark fw-bold">{product.name}</span>
                        {/* Cantidad/ Quantity*/}
                        <div>
                            <span className='px-3 label-card'>x {product.amount} </span>
                            <label className="fw-bold text-dark" translate='no'>$ {product.price.toFixed(2)}</label>
                        </div>

                    </div>
                    {/** Segment items */}
                    <>

                        {product.segments.map((segments) => (
                            <div className="d-flex justify-content-between" key={segments._id}>
                                {/* item name */}
                                <span className=" label-card">{segments.item.name}</span>
                            </div>
                        ))}

                        <div className='mt-2'>
                            <div>
                                <span className='label-card p-1' >
                                    Entrega: {product.delivery_type}
                                </span>
                            </div>
                            <div>
                                <RenderIf isTrue={product.note != ""}>
                                    <small className='text-danger p-1' >
                                        Nota: {product.note}
                                    </small>
                                </RenderIf>
                            </div>
                        </div>




                    </>
                </div>
            </div>
        ));
        return <>{items}</>
    }

    // funtion convert format voucher
    const formatVoucherString = () => {
        console.log("DATA DEL VOUCHER");

        let kinposVoucher = null
        if (orderData.bank_voucher_response) {
            try {
                let dataVoucher = JSON.parse(orderData.bank_voucher_response)
                if (dataVoucher.voucher) kinposVoucher = dataVoucher.voucher
            } catch (err) { console.log(err) }
        }

        let voucher = kinposVoucher || orderData.voucher_response || ""
        // Extraer el número de tarjeta ocultando los dígitos intermedios
        const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

        // Construir el string formateado del voucher
        const formattedVoucher = `${maskedVoucher}`;
        setformatVoucher(formattedVoucher)
    };

    return (<>


        <div className="pd">

            {/* ── HEADER ── */}
            <div className="pd-head">
                <div className="pd-head-main">
                    <span className="pd-head-ico"><i className="uil uil-receipt-alt" translate="no"></i></span>
                    <div className="pd-head-text">
                        <h2 className="pd-title">Detalles de Precuenta</h2>
                        <div className="pd-sub">
                            Orden <b>#{orderData.transaction_code ? orderData.transaction_code : 0}</b>
                            {orderData.order_type && <><span className="pd-sub-dot" />{orderData.order_type}</>}
                        </div>
                    </div>
                </div>
                <button
                    className="pd-icon-btn pd-icon-btn--danger"
                    type="button" title="Cerrar" aria-label="Cerrar"
                    onClick={() => handleCloseModal()}
                >
                    <i className="uil uil-multiply"></i>
                </button>
            </div>

            {/* ── INFO (cards) ── */}
            <div className="pd-info">
                <div className="pd-info-item">
                    <span className="pd-info-ico"><i className="uil uil-receipt-alt"></i></span>
                    <div className="pd-info-body">
                        <span className="pd-info-k">Orden</span>
                        <span className="pd-info-v"># {orderData.transaction_code ? orderData.transaction_code : 0}</span>
                    </div>
                </div>

                <div className="pd-info-item">
                    <span className="pd-info-ico"><i className="uil uil-user-circle"></i></span>
                    <div className="pd-info-body">
                        <span className="pd-info-k">Cliente</span>
                        <span className={`pd-info-v${!orderData.client_name ? ' is-empty' : ''}`}>
                            {!orderData.client_name ? "No Registrado" : orderData.client_name}
                        </span>
                    </div>
                </div>

                <div className='footer-modal-info-pre-order'>
                    {orderData.is_powertranz_pay == true ? <>

                        <div className='d-flex justify-content-between m-2'>
                            <button type="button" class="btn btn-warning" onClick={async () => voidPowertranz()} ><i class="uil uil-times-circle"></i> Rechazar</button>
                            <button type="button" class="btn btn-success" onClick={async () => capturePowertranz(orderData.total)}><i class="uil uil-check-circle"></i> Aprobar</button>
                        </div>
                    </> : <>
                        <RenderIf isTrue={statusDetailModalDinamic == true && (orderData.is_evertech_pay == false || orderData.is_evertech_pay == undefined)}>
                            <div className='d-flex justify-content-between mt-3'>
                                <span className="text-nowrap text-secondary h6 d-block">
                                    <div class="tooltip-container">
                                        <i class="uil uil-info-circle"></i>
                                        <span class="tooltip-text">Puedes reasignar la precuenta a una sucursal diferente.</span>
                                    </div>   Cambiar sucursal:
                                    <form className='filter-sp-trn'>
                                        <div className="d-block">
                                            <select className='form-select' name="user_branch" id="user_branch" onChange={(e) => setNewBranchoffice(e.target.value)}>
                                                <option value={0}> Seleccione una sucursal</option>
                                                {branchList()}
                                            </select>
                                        </div>
                                    </form>
                                </span>
                            </div>
                            <div className='text-end'>
                                <button type="button" class="btn btn-primary" onClick={async () => updatePreOrder()}  >Guardar</button>
                            </div>
                        </RenderIf></>}

                    {orderData.paymentInfo ?
                        <>
                            <PDFDownloadLink document={<DocPdf
                                doc_type={"invoice"} invoiceQR={orderData.dgi_qr} invoiceDate={orderData.createdAt} cufe={orderData.cufe} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                                receptor={{
                                    name: orderData.client_name,
                                    ruc: orderData.client_ruc,
                                    direction: "Panama",
                                    dv: orderData.client_dv,
                                }}
                                emitter={branchOfficeData}
                                products={orderData.groups} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                                totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                                invoiceShipping={orderData.delivery?.value || 0}
                            />} >
                                <button className='btn btn-success  rounded-2 mt-2' > <i class="uil uil-file-download"></i>  Descargar Factura Electrónica </button>
                            </PDFDownloadLink>
                        </> : <></>}
                </div>

                <div className="pd-info-item">
                    <span className="pd-info-ico"><i className="uil uil-store"></i></span>
                    <div className="pd-info-body">
                        <span className="pd-info-k">Sucursal</span>
                        <span className="pd-info-v">{orderData.branchoffice?.name || ""}</span>
                    </div>
                </div>

                <div className="pd-info-item">
                    <span className="pd-info-ico"><i className="fa-solid fa-cash-register"></i></span>
                    <div className="pd-info-body">
                        <span className="pd-info-k">Usuario</span>
                        <span className="pd-info-v">{orderData.machine_name} {!orderData.user ? 'No es cajera' : orderData.user.name}</span>
                    </div>
                </div>

                <RenderIf isTrue={orderData.is_evertech_pay}>
                    <div className="pd-info-item pd-info-item--wide">
                        <span className="pd-info-ico"><i className="uil uil-money-bill"></i></span>
                        <div className="pd-info-body">
                            <span className="pd-info-k">Pago</span>
                            <span className="pd-info-v">
                                {orderData.is_evertech_pay && orderData.evertech_transaction_status === "PENDING" ? "Pago pendiente de aprobacion, procesado por placetopay" : orderData.evertech_transaction_status}
                            </span>
                        </div>
                    </div>
                </RenderIf>

                {orderData.paymentInfo ? <>
                    {orderData.paymentInfo.map((payment, i) => (
                        <div className="pd-info-item" key={i}>
                            <span className="pd-info-ico"><i className="uil uil-credit-card"></i></span>
                            <div className="pd-info-body">
                                <span className="pd-info-k">Método de pago</span>
                                <span className="pd-info-v">{payment.name}</span>
                            </div>
                        </div>
                    ))}
                </> : <></>}
            </div>

            {/* ── GRID: productos + resumen ── */}
            <div className="pd-grid">

                {/* productos */}
                <section className="pd-card">
                    <div className="pd-card-head">
                        <span className="pd-card-title">Productos</span>
                        <span className="pd-card-side">Precio</span>
                    </div>

                    {/* Item cards */}
                    <div className="pd-items">
                        {orderItems()}
                    </div>

                    {orderData.deleted_code && (
                        <div className="pd-note">
                            <span className="pd-note-k">Tipo de eliminación</span>
                            <div className="pd-note-v">
                                {orderData.deleted_code == "USER_REQUEST" ? <>
                                    <span className="pd-badge pd-badge--danger"><i className="uil uil-user-nurse"></i> Eliminado por usuario</span>
                                </> : <>{orderData.deleted_code == "UNION_PAY" ? <>
                                    <span className="pd-badge pd-badge--primary"><i className="uil uil-compress-arrows"></i> Union de precuentas</span>
                                </> : <>{orderData.deleted_code == "DIVIDED_BILL" ? <>
                                    <span className="pd-badge pd-badge--primary"><i className="uil uil-arrows-resize"></i> Division de precuentas</span>
                                </> : <>
                                    <span className="pd-badge pd-badge--warn"><i className="uil uil-question-circle"></i></span>
                                </>}
                                </>}</>}
                            </div>
                        </div>
                    )}

                    <RenderIf isTrue={orderData.justification}>
                        <div className="pd-alert">
                            <i className="uil uil-exclamation-triangle"></i>
                            <span><b>Justificación:</b> {orderData.justification}</span>
                        </div>
                    </RenderIf>
                </section>

                {/* resumen */}
                <aside className="pd-card pd-card--summary">
                    <div className="pd-card-head">
                        <span className="pd-card-title">Detalles de orden</span>
                    </div>

                    <div className="pd-sum">
                        <div className="pd-sum-row">
                            <span className="pd-sum-k">Descuento</span>
                            <span className="pd-sum-v">${orderData.discount.toFixed(2)}</span>
                        </div>
                        <div className="pd-sum-row">
                            <span className="pd-sum-k">Subtotal</span>
                            <span className="pd-sum-v">${orderData.subtotal.toFixed(2)}</span>
                        </div>
                        {orderData.taxes.map((tax, i) => (
                            <div className="pd-sum-row" key={i}>
                                <span className="pd-sum-k">Impuesto ({tax.tax})</span>
                                <span className="pd-sum-v">${tax.total.toFixed(2)}</span>
                            </div>
                        ))}
                        <div className="pd-sum-total">
                            <span className="pd-sum-total-k">Total</span>
                            <span className="pd-sum-total-v">${orderData.total.toFixed(2)}</span>
                        </div>
                    </div>
                </aside>
            </div>

            {/* ── FOOTER / ACCIONES ── */}
            <div className="pd-foot">
                {orderData.is_powertranz_pay == true ? <>
                    <div className="pd-actions pd-actions--split">
                        <button type="button" className="pd-btn pd-btn--danger-outline" onClick={async () => voidPowertranz()}>
                            <i className="uil uil-times-circle"></i> Rechazar
                        </button>
                        <button type="button" className="pd-btn pd-btn--success" onClick={async () => capturePowertranz(orderData.total)}>
                            <i className="uil uil-check-circle"></i> Aprobar
                        </button>
                    </div>
                </> : <>
                    <RenderIf isTrue={statusDetailModalDinamic == true && (orderData.is_evertech_pay == false || orderData.is_evertech_pay == undefined)}>
                        <div className="pd-reassign">
                            <div className="pd-reassign-label">
                                <span className="pd-tip">
                                    <i className="uil uil-info-circle"></i>
                                    <span className="pd-tip-text">Puedes reasignar la precuenta a una sucursal diferente.</span>
                                </span>
                                Cambiar sucursal
                            </div>
                            <form className="pd-reassign-form filter-sp-trn">
                                <label className="pd-select-wrap" htmlFor="user_branch">
                                    <i className="uil uil-store"></i>
                                    <select className="pd-select" name="user_branch" id="user_branch" onChange={(e) => setNewBranchoffice(e.target.value)}>
                                        <option value={0}> Seleccione una sucursal</option>
                                        {branchList()}
                                    </select>
                                </label>
                                <button type="button" className="pd-btn pd-btn--primary" onClick={async () => updatePreOrder()}>
                                    Guardar
                                </button>
                            </form>
                        </div>
                    </RenderIf>
                </>}

                {orderData.paymentInfo ?
                    <>
                        <PDFDownloadLink className="pd-pdf-link pdf-viewer-sp" document={<DocPdf
                            doc_type={"invoice"} invoiceQR={orderData.dgi_qr} invoiceDate={orderData.createdAt} cufe={orderData.cufe} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                            receptor={{
                                name: orderData.client_name,
                                ruc: orderData.client_ruc,
                                direction: "Panama",
                                dv: orderData.client_dv,
                            }}
                            emitter={branchOfficeData}
                            products={orderData.groups} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                            totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                            invoiceShipping={orderData.delivery?.value || 0}
                        />} >
                            <button type="button" className="pd-btn pd-btn--primary pd-btn--block">
                                <i className="uil uil-file-download"></i> Descargar Factura Electrónica
                            </button>
                        </PDFDownloadLink>
                    </> : <></>}

                {/**Voucher button */}
                <RenderIf isTrue={orderData.bank_voucher_response != "0"}>
                    <button
                        type="button"
                        className="pd-btn pd-btn--outline pd-btn--block"
                        onClick={() => (handleViewCoucher())} title="Actualizar Lista"
                    >
                        <i className="uil uil-receipt-alt"></i> Voucher de transacción
                    </button>
                </RenderIf>
            </div>

        </div>
        <Modal
            show={modalShowVoucher}
            onHide={() => setmodalShowVoucher(false)}
            centered>
            <Modal.Header>
                Voucher de transaccion: #{orderData.transaction_code}
            </Modal.Header>
            <Modal.Body>
                <div>
                    <pre>{formatVoucher}</pre>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
            </Modal.Footer>
        </Modal>

    </>);
}

export default OrderDetailPreOrder;